import type { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { toAttributeCase } from "../../utils/strings";
import ActionButton from "../../widget/action-button";
import ButtonsGroup from "../../widget/buttons-group";
import Panel from "../../widget/panel";
import Restricted from "../../widget/restricted";
import TwoColumns from "../../widget/two-columns";
import "./menu-item.css";

export function MenuItem(props: {
  title: string;
  requires?: string;
  versalIcon?: string;
  children: React.ReactNode;
  buttonText?: string;
  toRoute?: string;
  toLocation?: string;
  buttons?: ReactElement<typeof ActionButton>[];
}) {
  const navigate = useNavigate();

  return (
    <Restricted to={props.requires}>
      <div className="menu-item">
        <Panel
          header={props.title}
          fixed={true}
          testid={toAttributeCase(props.title)}
        >
          <TwoColumns>
            {props.versalIcon && (
              <img className="versal-icon" src={props.versalIcon} />
            )}
            <div className="description">{props.children}</div>
          </TwoColumns>
          <ButtonsGroup>
            {props.buttons || (
              <ActionButton
                action={props.buttonText}
                discrete={true}
                onOk={() =>
                  props.toLocation
                    ? (document.location = props.toLocation)
                    : navigate(props.toRoute ?? "")
                }
              />
            )}
          </ButtonsGroup>
        </Panel>
      </div>
    </Restricted>
  );
}
